import type { AdminTransactionRow } from "./types";

/** True when the API returned rows that are NOT the requested customer's — which
 *  means it ignored the `customerId` filter rather than applying it.
 *
 *  tsoa drops undeclared query params instead of rejecting them, so an omg-api
 *  deployed before fgsake/fgsake-monorepo#419 answers `?customerId=…` with the
 *  full, unfiltered table. A page that renders those rows as one member's
 *  transactions is silently wrong, and every row links into somebody else's
 *  transaction detail. Deploy ordering is the intended protection, but it is a
 *  human step; this makes the failure visible instead of plausible.
 *
 *  An empty result is not evidence of anything either way, so it returns false —
 *  a member with no transactions renders the normal empty state. */
export const apiIgnoredCustomerFilter = (
  rows: readonly Pick<AdminTransactionRow, "customerId">[],
  requestedCustomerId: string | undefined,
): boolean => {
  if (!requestedCustomerId) return false;
  return rows.some((row) => row.customerId !== requestedCustomerId);
};
